export default {
    headerCollapseDistance: 60, //pixels scrolled before header collapses
    currentStore: "shopify",
    currentMobileStore: "shopify",
    store: {
        amazon: {
            url: "http://www.amazon.com/gp/product/B00XEW3YD6/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B00XEW3YD6&linkCode=as2&tag=eero-20&linkId=DAJHIK5YGTI6Z7HR",
            copy: "Buy on Amazon",
            props: {
                target: "_blank",
                rel: "nofollow"
            }
        },
        shopify: {
            url: "https://store.eero.com/",
            copy: "Buy now"
        }
    },
    regions: ["US"],
    mailingListUrl: "https://eero-mailing-list.firebaseio.com",
    mobileApp: {
        ios: "https://itunes.apple.com/us/app/eero-home-wifi-system/id1023499075?ls=1&mt=8",
        android: "https://play.google.com/store/apps/details?id=com.eero.android&hl=en"
    }
};



/** WEBPACK FOOTER **
 ** ./app/config/config.js
 **/